import script from "./IsSpin.vue?vue&type=script&setup=true&lang=js"
export * from "./IsSpin.vue?vue&type=script&setup=true&lang=js"

import "./IsSpin.vue?vue&type=style&index=0&id=9bf08ed8&lang=scss"

const __exports__ = script;

export default __exports__